module.exports = __webpack_public_path__ + "img/section4Content2.0fb4a712.png";